import { DateInput, FormElement, TextAreaInput, TimeInput } from 'b3';
import React from 'react';
import { connect } from 'react-redux';
import { openModal } from '../../actions/ModalActions';
import ContactCardDropdown from '../../components/contact-card/ContactCardDropdown';
import CreateContactModal from '../../components/CreateContactModal';
import StaffMemberPicker from '../../components/StaffMemberPicker';
import ShortcutButton from '../shortcut-button/ShortcutButton';
import CompleteButton from './CompleteButton';
import { completeWithNoFollowUpCall, completeWizard, goBack, goToStep, updateScheduledCallData } from './logActivityReducer';

@connect(
    state => ({
        contacts: state.activeClient.contacts,
        client: state.activeClient.client,
        scheduledCallData: state.logActivityWizard.scheduledCallData,
        employees: state.users.users,
        description: state.logActivityWizard.callData.description
    }),
    { openModal, goToStep, updateScheduledCallData, completeWizard, completeWithNoFollowUpCall, goBack }
)
export default class BookFollowUpCallStep extends React.Component {
    componentDidMount() {
        if(document.activeElement && document.activeElement.tagName !== 'TEXTAREA') {
            this.textInput.focus();
        }
    }
    updateTime(newTime) {
        var date = this.props.scheduledCallData.date
            .hours(newTime.hours())
            .minutes(newTime.minutes());

        this.props.updateScheduledCallData({date});
    }
    updateDate(newDate) {
        var date = this.props.scheduledCallData.date
            .date(newDate.date())
            .year(newDate.year())
            .month(newDate.month());

        this.props.updateScheduledCallData({date});
    }
    showCreateContactModal(e) {
        e.preventDefault();
        this.props.openModal(CreateContactModal, {clientId: this.props.client.id});
    }
    canSubmit() {
        // check has date, assignedTo and Contact
    	return true;
    }
    handleContactChange(participatingContactId) {
        this.props.updateScheduledCallData({participatingContactId});
    }
    updateDescription(description) {
        this.props.updateScheduledCallData({description});   
    }
    handleEmployeeSelected(employee) {
        this.props.updateScheduledCallData({assignedEmployees: [employee]});
    }
    handleEmployeeDeselected(employee) {
        this.props.updateScheduledCallData({assignedEmployees: []});
    }
    handleNoFollowUp() {
        this.props.completeWithNoFollowUpCall();
    }
    onUserSelected(assignedEmployeeIds) {
        this.props.updateScheduledCallData({assignedEmployeeIds});
    }
    useLast = (e) => {
        e.preventDefault();
        var description = this.props.description;
        this.props.updateScheduledCallData({description});   
    }
    render() {
        var { client, scheduledCallData, contacts } = this.props;
        var { date, description, participatingContactId, assignedEmployeeIds } = scheduledCallData;

        return (
        	<div className="wizard-step-wrapper">
                <h1>Book follow up Phone Call</h1>
                <div style={{display: "flex"}}>
                    <h2 style={{marginRight: 15}}>Time</h2>
                    <div style={{flex: 1}}>
                        <FormElement icon="clock-2">
                            <TimeInput
                                value={date}
                                onChange={this.updateTime.bind(this)}
                            />
                        </FormElement>
                    </div>
                    <div style={{flex: 1}}>
                        <FormElement icon="calendar-2" style={{width: "170px"}}>
                            <DateInput
                                submitOnChangeOnly={true}
                                value={date}
                                onChange={this.updateDate.bind(this)}
                            />
                        </FormElement>
                    </div>
                </div>
                <div style={{display: 'flex', alignItems: 'center', marginTop: 15}}>
                    <h2 style={{margin: 0}}>
                        Assigned To
                    </h2>
                    <div style={{flex: 1, marginLeft: 15}}>
                        <StaffMemberPicker 
                            onSelectChange={this.onUserSelected.bind(this)}
                            includeAvatarPicker={false}
                            onlyOneAssign={true} 
                            assignedUserIds={assignedEmployeeIds} 
                            callersOnly={true} />
                    </div>
                </div>
                <div>
                    <h2>Call Contact</h2>
                    <ContactCardDropdown
                        selectedContactId={participatingContactId}
                        onChange={this.handleContactChange.bind(this)}
                        contacts={contacts}
                        clientId={client.id} />
                </div>
                <div style={{display: 'flex', alignItems: 'center', marginTop: 15}}>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <h2 style={{marginTop: 0, marginBottom: 5}}>
                            Agenda
                        </h2>
                        <a onClick={this.useLast} href="#">Repeat Last</a>
                    </div>
                    
                    <div style={{flex: 1, marginLeft: 35}}>
                        <TextAreaInput 
                            ref={el => this.textInput = el}
                            rows={4}
                            placeholder="Enter the agenda for the next call"
                            value={description} 
                            onChange={this.updateDescription.bind(this)} />
                    </div>
                </div>
                <div className="actions-row">
                    <ShortcutButton shortcut="n" type="danger" onClick={this.handleNoFollowUp.bind(this)}>
                        No follow up
                    </ShortcutButton>
                    <CompleteButton />
                </div>
        	</div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/BookFollowUpCallStep.js